export default __webpack_public_path__ + "static/media/mountain-landscape-desk-3x.10235d65.webp";